<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFecc_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13.392 9.47 11.8 11.063l-.735-.736 1.593-1.592a1.04 1.04 0 0 0 0-1.471L11.063 5.67l.736-.735 1.593 1.593a2.08 2.08 0 0 1 0 2.942ZM7.265 3.343 5.672 4.935 4.937 4.2 6.53 2.607a2.08 2.08 0 0 1 2.941 0L11.063 4.2l-.735.736-1.592-1.592a1.04 1.04 0 0 0-1.47 0ZM4.937 5.67l-.735-.736-1.593 1.593a2.08 2.08 0 0 0 0 2.942l1.593 1.593.735-.736-1.593-1.592a1.04 1.04 0 0 1 0-1.471L4.937 5.67Zm6.127 6.127-.735-.735-1.593 1.593a1.04 1.04 0 0 1-1.47 0l-1.594-1.594-.735.736 1.593 1.593a2.08 2.08 0 0 0 2.941 0l1.593-1.593ZM8 9.82a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64Z"
        clip-rule="evenodd"
    />
</svg>
